import { ApiError, NetworkError } from "../api/client";

/**
 * Renders an error the way the API described it. The server's `message` is the
 * copy: for 403s and 404s it is written to be read by an operator, and
 * replacing it with "Something went wrong" would hide the only useful part.
 */
export function ErrorNotice({ error }: { error: unknown }) {
  if (!error) return null;
  const status = error instanceof ApiError ? error.status : null;
  const message =
    error instanceof NetworkError
      ? "Could not reach the API. Check VITE_API_BASE_URL and that the API is running."
      : error instanceof Error
        ? error.message
        : "Something went wrong";
  return (
    <div className="notice notice-error" role="alert">
      {status ? `${status}: ` : ""}
      {message}
    </div>
  );
}

/**
 * The one loading indicator: a ring with a single coloured arc, and the name of
 * whatever is being waited on.
 *
 * `role="status"` rather than a bare div, so a screen reader is told something
 * is in flight instead of finding an empty region where a table will be. `lg`
 * is the app-boot case, which is alone on the screen rather than inside a
 * panel.
 */
export function Loading({ what, size }: { what?: string; size?: "lg" }) {
  return (
    <div className={size === "lg" ? "spinner spinner-lg" : "spinner"} role="status">
      <span className="spinner-ring" aria-hidden="true" />
      <span>{what ? `Loading ${what}...` : "Loading..."}</span>
    </div>
  );
}
